// Authentication error handling and mapping

export class AuthError extends Error {
  public code: string;
  public details?: unknown;

  constructor(code: string, message: string, details?: unknown) {
    super(message);
    this.name = 'AuthError';
    this.code = code;
    this.details = details;
  }
}

// Firebase error code mapping
export const FIREBASE_ERROR_MESSAGES: Record<string, string> = {
  'auth/user-not-found': 'No account found with this email address.',
  'auth/wrong-password': 'Incorrect password. Please try again.',
  'auth/email-already-in-use': 'An account with this email already exists.',
  'auth/weak-password': 'Password should be at least 6 characters long.',
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/too-many-requests': 'Too many failed attempts. Please try again later.',
  'auth/user-disabled': 'This account has been disabled.',
  'auth/operation-not-allowed': 'This operation is not allowed.',
  'auth/network-request-failed': 'Network error. Please check your connection.',
  'auth/popup-closed-by-user': 'Sign-in was cancelled.',
  'auth/cancelled-popup-request': 'Sign-in was cancelled.',
  'auth/popup-blocked': 'Sign-in popup was blocked. Please allow popups for this site.',
  'auth/configuration-not-found': 'Google Sign-In is not configured. Please contact support.',
  'auth/unauthorized-domain': 'This domain is not authorized for Google Sign-In.',
};

export function mapFirebaseError(firebaseError: unknown): AuthError {
  const error = firebaseError as { code?: string; message?: string };
  const code = error.code || 'auth/unknown-error';
  const message = FIREBASE_ERROR_MESSAGES[code] || error.message || 'An unexpected error occurred.';

  return new AuthError(code, message, firebaseError);
}

export function createAuthError(code: string, message: string, details?: unknown): AuthError {
  return new AuthError(code, message, details);
}
